<template>
  <el-dropdown v-if="teamSelected" trigger="hover">
    <span class="el-dropdown-link">
      {{ $t('common.team') }}
      <i class="el-icon-arrow-down el-icon--right" />
    </span>

    <el-dropdown-menu slot="dropdown">
      <div class="team-list-container">
        <el-dropdown-item
          v-for="(item, index) in teamList"
          :key="index"
          :disabled="teamToken === item['team_id']"
          class="team-container"
          @click.native="changeTeam(item)"
        >
          <el-image :src="item.avatar" fit="contain">
            <i slot="error" class="el-icon-office-building" />
          </el-image>

          <div>
            <div>
              {{ item.first_name }} {{ item.last_name }}
            </div>
            <div v-if="item.phone">
              {{ item.phone }}
            </div>
          </div>
        </el-dropdown-item>
      </div>

      <el-dropdown-item divided @click.native="manageTeam">
        {{ $t('common.manage') }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'TcDropdownTeam',
  computed: {
    ...mapGetters([
      'teamToken',
      'teamSelected',
      'teamList'
    ])
  },
  methods: {
    changeTeam(item) {
      if (item['team_id'] !== this.teamToken) {
        this.$store.dispatch('user/setTeamToken', item['team_id'])
        this.$store.dispatch('user/setTeamSelected', item)
      }
    },
    manageTeam() {
      this.$router.push('/team/team')
    }
  }
}
</script>

<style scoped lang="scss">
.el-image {
  width: 24px;
  height: 24px;
  border-radius: 5px;

  .el-icon-office-building {
    font-size: 24px;
  }
}

.el-dropdown-menu__item {
  text-align: center;
}

.team-list-container {
  max-height: 200px;
  overflow: auto;
}

.team-container {
  display: flex;
  align-items: center;
  grid-gap: 15px;
  text-align: left;
}
</style>
